
export const testClientList = [{
  "idx": 231,
  "name": "삼성전자",
  "ceoName": "김기남",
  val: 10
}, {
  "idx": 232,
  "name": "SK하이닉스",
  "ceoName": "박정호",
  val: 8
}, {
  "idx": 233,
  "name": "NAVER",
  "ceoName": "한성숙",
  val: 6
}, {
  "idx": 234,
  "name": "카카오",
  "ceoName": "여민수",
  val: 3
}, {
  "idx": 235,
  "name": "LG전자",
  "ceoName": "권봉석",
  val: 2
}, ]